import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "aside-logo flex-column-auto",
  id: "kt_aside_logo"
}
const _hoisted_2 = {
  key: 0,
  href: "#"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  href: "#"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "svg-icon svg-icon-1 rotate-180" }
const _hoisted_7 = { class: "aside-menu flex-column-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTMenu = _resolveComponent("KTMenu")!
  const _directive_exclude_tab_order = _resolveDirective("exclude-tab-order")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: "kt_aside",
    class: _normalizeClass(["aside", [
      !_ctx.isAsideHoverSuppressed && 'aside-hoverable',
      _ctx.asideTheme === 'light' && 'aside-light',
      _ctx.asideTheme === 'dark' && 'aside-dark',
    ]]),
    onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleAsideMouseLeave && _ctx.handleAsideMouseLeave(...args))),
    "data-kt-drawer": "true",
    "data-kt-drawer-name": "aside",
    "data-kt-drawer-activate": "{default: true, lg: false}",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.asideTheme === 'dark')
        ? (_openBlock(), _createElementBlock("a", _hoisted_2, [
            _createElementVNode("img", {
              alt: "Logo",
              src: _ctx.darkLogo,
              class: "h-75px logo"
            }, null, 8, _hoisted_3)
          ]))
        : _createCommentVNode("", true),
      (_ctx.asideTheme === 'light')
        ? (_openBlock(), _createElementBlock("a", _hoisted_4, [
            _createElementVNode("img", {
              alt: "Logo",
              src: _ctx.lightLogo,
              class: "h-75px logo"
            }, null, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        id: "kt_aside_toggle",
        class: _normalizeClass(["btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle", { active: _ctx.isAsideMinimized }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleAsideMinimize && _ctx.toggleAsideMinimize(...args)), ["prevent"]))
      }, [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr080.svg" })
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_KTMenu)
    ])
  ], 34)), [
    [_directive_exclude_tab_order]
  ])
}